module.exports = __webpack_public_path__ + "assets/suzhi-silogan.65b44ae.png";